import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import event, { EVENTS } from '../../lib/event.js';
import styles from './style.css';
import {GUIDE_MODE} from '../../lib/constant';

class StepCardLineBtn extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClick'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    handleClick(item) {
        // event.emit(EVENTS[`STEP_${item}`]);
        event.emit(EVENTS[`${item.event}`], item);
    }


    render() {
        const { btn, btnType,mode,stepLast } = this.props;
        const btnColor = btn.disable ? `${styles.grayBtn}` : btnType === 'blue' ? `${styles.blueBtn}` : `${styles.yellowBtn}`;

        return (
            <button
                className={`${styles.buttonGroup} ${btnColor}`}
                disabled={btn.disable}
                onClick={() => this.handleClick(btn)}
                style={{ display: mode === GUIDE_MODE && btn.event === EVENTS.STEP_ENTER_GUIDE_MODE ? 'none' : '' }}
            >
                { btn.button }
            </button>
        );
    }
}

export default StepCardLineBtn;
